// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1jIu3","content":"RecentSearches_content__1hsZ5"};